export default function Grid(theme) {
  return {
    MuiGrid: {
      styleOverrides: {},
    },
  };
}
